function RearrangeInputsModal() {
    return (
        <div>RearrangeInputsModal</div>
    )
}

export default RearrangeInputsModal;
